import PropTypes from 'prop-types'
import useEducationAnalytics from '../hooks/useEducationAnalytics'

EducationAnalytics.propTypes = {
  category: PropTypes.string,
  action: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  payload: PropTypes.object,
  referenceId: PropTypes.string,
  referenceType: PropTypes.string,
  googleAnalytics: PropTypes.bool,
  children: PropTypes.func,
  skip: PropTypes.bool,
  debounce: PropTypes.number
}

export default function EducationAnalytics({
  category,
  action,
  label,
  payload,
  referenceId,
  referenceType,
  googleAnalytics = true,
  children,
  skip = false,
  debounce
}) {
  const track = useEducationAnalytics({
    category,
    action,
    label,
    payload,
    referenceId,
    referenceType,
    googleAnalytics,
    trackOnMount: !children,
    skip,
    debounce
  })

  return children ? children(track) : null
}
